<app-filter-header title="Filtrar resoluciones" i18n-title (apply)="this.apply()" (reset)="this.reset()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-date-edit class="col-sm-6" label="DataIni" [(value)]="filter.dataIni"></app-form-date-edit>
    <app-form-date-edit class="col-sm-6" i18n-label label="DataFi" [(value)]="filter.dataFi"></app-form-date-edit>
  </div>
</div>